/**
 * `/__ui/dashboard` — the visual-regression harness for M7 (the trick B4's board harness uses).
 * It renders with **no session, no api and no database**, so a served build can be hit-tested
 * against the geometry measured on production
 * (`discovery/ui-reference/dashboards/INDEX.md`).
 *
 *   `?screen=canvas` (default) · `empty` · `readonly`
 */
import { WidgetCanvas } from './WidgetCanvas';
import { useFixtureDashboardSource } from './fixture';
import './dashboards.css';

export function DashboardHarness() {
  const params = new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search);
  const screen = params.get('screen') ?? 'canvas';
  const source = useFixtureDashboardSource({
    empty: screen === 'empty',
    readOnly: screen === 'readonly',
  });
  return (
    <div data-testid={`ui-dashboard-${screen}`} style={{ minHeight: '100vh' }}>
      <WidgetCanvas source={source} showNewItem measureTitle={(key) => (key === 'time_tracking' ? 'Time tracking' : key)} />
    </div>
  );
}
